import { v4 as uuidv4 } from "uuid";

export function addIdToObject(list) {
  return list.map((item) => ({
    ...item,
    id: `fallback_${uuidv4()}`
  }));
}